export const k = {
    pageTitle: "domains.application.pages.home-page.home-page-i18n.pageTitle",
    message: "domains.application.pages.home-page.home-page-i18n.message"
};
export const translations = {
    da: {
        pageTitle: "Advosys",
        message: "Vælg noget i menuen til venstre."
    },
    en: {
        pageTitle: "Unik Advosys",
        message: "Make a selection in the menu to the left."
    }
};
